import { ComponentCartLine } from '@mockly/component-cart-line';
import { CartUpdateEvent } from '@mockly/events';
import { cart } from '@mockly/cart';

const selectors = {
  decreaseButton: '[data-decrease-button]',
  increaseButton: '[data-increase-button]',
  value: '[data-quantity-value]',
  input: '[data-quantity-input]',
}

class ComponentCartLineQuantity extends ComponentCartLine {
  quantity = 1;

  constructor() {
    super();

    this.handleDecrease = this.handleDecrease.bind(this);
    this.handleIncrease = this.handleIncrease.bind(this);
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
  }

  updateValues(quantity) {
    this.quantity = quantity;
    this.value.textContent = this.quantity?.toString().padStart(2, '0');
    this.input.value = this.quantity;
  }

  handleCartUpdate(event) {
    const newQuantity = event.cart?.items?.find(item => item.key === this.id)?.quantity;
    if (!newQuantity) return;

    this.quantity = newQuantity;
    this.updateValues(newQuantity);
  }

  setButtonStates(loading = false) {
    if (loading) {
      this.decreaseButton.setAttribute('disabled', true);
      this.increaseButton.setAttribute('disabled', true);
      this.decreaseButton.setAttribute('aria-busy', true);
      this.increaseButton.setAttribute('aria-busy', true);
    } else {
      this.decreaseButton.removeAttribute('disabled');
      this.increaseButton.removeAttribute('disabled');
      this.decreaseButton.removeAttribute('aria-busy');
      this.increaseButton.removeAttribute('aria-busy');
    }
  }

  async handleDecrease() {
    this.setButtonStates(true);

    const newQuantity = this.quantity - 1;

    if (newQuantity === 0) {
      this.cartLine.removeLine();
      this.setButtonStates(true);
      return;
    }

    this.updateValues(newQuantity);

    try {
      await cart.update({ id: this.id, quantity: newQuantity });
    } catch (error) {
      console.error('Failed to decrease quantity', error);
      return;
    } finally {
      this.setButtonStates(false);
    }
  }

  async handleIncrease() {
    this.setButtonStates(true);

    const newQuantity = this.quantity + 1;

    this.updateValues(newQuantity);
    
    try {
      await cart.update({ id: this.id, quantity: newQuantity });
    } catch (error) {
      console.error('Failed to increase quantity', error);
      return;
    } finally {
      this.setButtonStates(false);
    }
  }

  connectedCallback() {
    this.id = this.dataset.id;

    this.cartLine = this.closest('cart-line');
    this.decreaseButton = this.querySelector(selectors.decreaseButton);
    this.increaseButton = this.querySelector(selectors.increaseButton);
    this.input = this.querySelector(selectors.input);
    this.value = this.querySelector(selectors.value);

    this.quantity = this.input?.value ?? 1;

    this.decreaseButton?.addEventListener('click', this.handleDecrease);
    this.increaseButton?.addEventListener('click', this.handleIncrease);
    
    window.addEventListener(CartUpdateEvent.eventName, this.handleCartUpdate);
  }

  disconnectedCallback() {
    this.decreaseButton?.removeEventListener('click', this.handleDecrease);
    this.increaseButton?.removeEventListener('click', this.handleIncrease);
    window.removeEventListener(CartUpdateEvent.eventName, this.handleCartUpdate);
  }
}

if (!customElements.get('cart-line-quantity')) {
  customElements.define('cart-line-quantity', ComponentCartLineQuantity);
}